import React from 'react';

import { useAppSelector } from 'src/store/reducers';

import Loader from '@helsenorge/designsystem-react/components/Loader';

type Props = {
  children?: React.ReactNode;
};

// eslint-disable-next-line react-refresh/only-export-components
export const shouldRender = (
  isMicroweb: boolean,
  isMicrowebStep: boolean,
  showLocalSpinner: boolean | undefined,
  showGlobalSpinner: boolean | undefined
): boolean => {
  // Spesialhåndtering for prosessflyt Microweb hvor det ikke er ønskelig UI-messig å rendre skjema når spinner loades
  // Merk: Pga pot. issues med revalidering ved mellomlagring for vanlig skjema så rendres skjema alltid uansett!
  if (isMicroweb && isMicrowebStep) {
    if (showLocalSpinner || showGlobalSpinner) {
      return false;
    } else {
      return true;
    }
  }
  return true;
};

export const SkjemaSpinners = ({ children }: Props): React.JSX.Element | React.ReactNode => {
  const showLocalSpinner = useAppSelector(state => state.refero.ui.showLocalSpinner);
  const showGlobalSpinner = useAppSelector(state => state.refero.ui.showGlobalSpinner);

  return showGlobalSpinner ? (
    <Loader size="large" overlay={'screen'} color="black" />
  ) : showLocalSpinner ? (
    <div className="page_refero__spinnerspacing">
      <Loader size={'large'} color="black" />{' '}
    </div>
  ) : (
    children
  );
};
